import React, { useState, useEffect, ChangeEvent } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getTaggingInformationScreen } from '../../../../utils/Tagging';
import { sendTagging } from '../../../../store/ducks/tagging/actions';
import { ICustomerQualityCertificateItem } from '../../../../store/ducks/download-area/types';
import { ApplicationState } from '../../../../store';
import { Title } from '@gerdau/hefesto/Title';
import { SearchField } from '@gerdau/hefesto/SearchField';
import { Button } from '@gerdau/hefesto/Button';
import { Container, FilterContent, SearchAndActionsBlock } from './styles';
import moment from 'moment';
import { QualityCertifcateTable } from './QualityCertificateTable';
import { useLocation } from 'react-router-dom';

const QualityCertificateTabContent: React.FC = () => {
  const dispatch = useDispatch();
  const { screenName = '', itemDescription = '' } =
    getTaggingInformationScreen('download-area');

  const [searchInput, setSearchInput] = useState<string>();
  const [qualityCertificatesData, setQualityCertificatesData] = useState<
    ICustomerQualityCertificateItem[]
  >([]);

  const downloadAreaState = useSelector(
    (state: ApplicationState) => state.downloadArea
  );
  const qualityCertificatesState = useSelector(
    (appState: ApplicationState) =>
      appState.downloadArea.qualityCertificatesState
  );
  const { pathname } = useLocation();
  useEffect(() => {
    dispatch(
      sendTagging({
        screenName: `${screenName}:CertificadoDeQualidade`,
        page: pathname,
        event: 'page_view'
      })
    );
  }, []);

  const upddateTableData = () => {
    setQualityCertificatesData(qualityCertificatesState.items);
  };

  useEffect(() => {
    upddateTableData();
  }, [qualityCertificatesState.items]);

  const onFilter = (newSearchInputValue: string) => {
    setSearchInput(newSearchInputValue);
    const filteredItems = qualityCertificatesState.items.filter(
      (item: ICustomerQualityCertificateItem) =>
        item.orderNumber.includes(newSearchInputValue) ||
        item.invoiceNumber.includes(newSearchInputValue) ||
        item.sku.includes(newSearchInputValue) ||
        (item.itemBillingDate &&
          moment(item.itemBillingDate, 'YYYY-MM-DD')
            .format('DD/MM/YYYY')
            .includes(newSearchInputValue)) ||
        item.materialDescription.includes(newSearchInputValue)
    );

    setQualityCertificatesData(filteredItems);
  };

  const onClickClean = () => {
    dispatch(
      sendTagging({
        screenName: `${screenName}:CertificadoDeQualidade`,
        itemDescription: `${itemDescription}_certificadoDeQualidade_limparFiltros`,
        itemName: 'button:limpar_filtros',
        filterInfo: `#flt:${searchInput}`,
        event: 'click'
      })
    );
    setSearchInput('');
    setQualityCertificatesData(qualityCertificatesState.items);
  };

  return (
    <>
      {downloadAreaState.qualityCertificatesState.items.length > 0 && (
        <Container>
          <FilterContent>
            <Title level={3}>Filtros</Title>
            <SearchAndActionsBlock>
              <SearchField
                label="Pesquisar"
                placeholder="Pesquisar por nº do pedido, nº da NF, código do material, data de faturamento ou descrição do produto"
                name="search"
                inputValue={searchInput}
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                  onFilter(e.target.value);
                }}
                disabled={
                  downloadAreaState.qualityCertificatesState.loading ||
                  downloadAreaState?.qualityCertificatesState.items.length === 0
                }
              />

              <Button
                type="button"
                name="btnCleanFilters"
                onClick={onClickClean}
                variant="secondary"
                disabled={!searchInput}
                loading={downloadAreaState.qualityCertificatesState.loading}
              >
                Limpar filtros
              </Button>
            </SearchAndActionsBlock>
          </FilterContent>
        </Container>
      )}
      {!downloadAreaState.qualityCertificatesState.loading && (
        <QualityCertifcateTable
          customerQualityCertificateItems={qualityCertificatesData}
        />
      )}
    </>
  );
};

export default QualityCertificateTabContent;
